export const mutationTypes = {};

const mutations = {};

export default mutations;
